import {List} from 'immutable';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {translate} from 'react-i18next';

import * as productActions from '../actions/productActions';
import * as basketActions from '../actions/basketActions';
import BasketLayout from './Basket';
import ProductTypeView from '../components/Product/ProductTypeView';
import ProductListView from '../components/Product/ProductListView';
import * as _ from 'lodash';
import * as restaurantActions from '../actions/restaurantActions';

import Spinner from '../components/Spinner/Spinner';


class ProductScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidUpdate() {
    let {originalFilterType, match, selectType, selectCategory} = this.props;
    const currentType = match.params.type;
    if (currentType && currentType !== originalFilterType) {
      selectType(currentType);
      selectCategory('all');
    }
  }

  static getDerivedStateFromProps(props, state) {
    const selectedtype = props.match.params.type;
    if (!selectedtype) {
      props.history.replace(`/${props.currentRestaurant.name_for_url}/products/pizza`);
    }
    if (props.types.size && selectedtype !== 'deals') {
      const type = props.types.find(t => t.name === selectedtype);
      if (!type) {
        props.history.replace('/not-found');
      }
    }
    return state;
  }

  render() {
    const {
      selectType, categories, basket, filterType, types, pizzaCategories,
      addToCard, selectCategory, filterCategory, language, restaurants,
      currentRestaurant, clearBasket, ingredients, products, t
    } = this.props;
    if (!products[filterType]) return <Spinner text={t(`loading_${filterType}`)} />;
    if (!List.isList(types)) return <Spinner text={t('loading_types')}/>;
    if (!List.isList(categories)) return <Spinner text={t('loading_categories')}/>;
    if (!List.isList(pizzaCategories)) return <Spinner text={t('loading_pizzas_categories')}/>;
    if (!List.isList(ingredients)) return <Spinner text={t('loading_ingredients')}/>;

    return (
      <div className="app__wrapper">
        <ProductTypeView
          restaurants={restaurants}
          selectedRestaurant={currentRestaurant}
          changeRestaurant={this.props.restaurantSelect}
          types={types}
          selectType={selectType}
          selectCategory={selectCategory}
          language={language.defaultLanguage}
          clearBasket={clearBasket}
          basket={basket}
        />
        <div className="products">
          <ProductListView
            products={products[filterType]}
            filterType={filterType}
            basket={basket}
            addToCard={addToCard}
            categories={categories}
            pizzaCategories={pizzaCategories}
            selectCategory={selectCategory}
            sizeAll={products[filterType].size}
            filterCategory={filterCategory}
            language={language.defaultLanguage}
            ingredients={ingredients.toArray()}
            currentRestaurant={currentRestaurant}
          />
          <BasketLayout/>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let products = {};
  let filteredProduct = List();
  let pizzas = List();
  let filterPizzasByCategory = List();
  let filteredProductByCategory = List();
  let productCategoriesNew = [];
  let pizzaCategories = [];
  const restaurants = state.restaurants;
  let currentRestaurant = {};
  if (!_.isEmpty(restaurants.item)) {
    currentRestaurant = restaurants.item;
    pizzas = List(currentRestaurant.pizzas);
    filteredProduct = List(currentRestaurant.products);
    // filter products by type
    filteredProduct = filteredProduct.filter(obj => {
      return obj.type && obj.type.name === state.products.filterType && !obj.deals_only;
    });
    filterPizzasByCategory = pizzas;
    filteredProductByCategory = filteredProduct;
    // filter by category
    const {filterCategory} = state.products;
    if (filterCategory) {
      if (filterCategory !== 'all') {
        filterPizzasByCategory = pizzas.filter(obj => {
          return obj.categories.filter(category => {
            return category.id === filterCategory;
          }).length;
        });
        filteredProductByCategory = filteredProduct.filter(obj => {
          return obj.categories.filter(category => {
            return category.id === filterCategory;
          }).length;
        });
      }
    }
    const deals = _.orderBy(currentRestaurant.deals, 'position', ['asc']);
    // sort deals composition
    deals.forEach(obj => {
      if (obj.compositions) {
        obj.compositions = _.orderBy(obj.compositions, 'type', ['asc']);
      }
    });
    products = {
      pizza: filterPizzasByCategory,
      product: filteredProductByCategory,
      deals: List(deals),
    };
    //get product categories by type
    let productCategories = [];
    filteredProduct.forEach(product => {
      return product.categories.filter(category => {
        return category.id && productCategories.push({
          ...category,
          total: filteredProduct.size,
        });
      });
    });
    const countCategories = _.countBy(productCategories, 'name');
    productCategoriesNew = _.uniqBy(productCategories, 'name');
    productCategoriesNew.forEach(obj => {
      obj.count = countCategories[obj.name];
      return obj;
    });
    productCategoriesNew = _.sortBy(productCategoriesNew, ['name']);
    state.products.pizzaCategories.forEach(obj => {
      const r = pizzas.filter(pizza => {
        return pizza.categories.filter(category => {
          return category.id === obj.id;
        }).length;
      });
      return r.size && pizzaCategories.push({
        count: r.size,
        total: pizzas.size,
        ...obj,
      });
    });
    pizzaCategories = _.sortBy(pizzaCategories, ['name']);
  }
  let filterType;
  if (_.includes(['deals', 'pizza'], state.products.filterType)) {
    filterType = state.products.filterType;
  } else {
    filterType = 'product';
  }
  return {
    language: state.language,
    categories: List(productCategoriesNew),
    pizzaCategories: List(_.uniqBy(pizzaCategories, 'id')),
    types: state.products.types,
    ingredients: state.products.ingredients,
    filterType: filterType,
    originalFilterType: state.products.filterType,
    products: products,
    basket: state.basket,
    filterCategory: state.products.filterCategory,
    restaurants: restaurants.list || [],
    currentRestaurant: currentRestaurant,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectType: bindActionCreators(productActions.selectType, dispatch),
    addToCard: bindActionCreators(basketActions.addToBasket, dispatch),
    selectCategory: bindActionCreators(productActions.selectCategory, dispatch),
    restaurantSelect: bindActionCreators(restaurantActions.selectedRestaurant, dispatch),
    clearBasket: bindActionCreators(basketActions.clearBasket, dispatch),
  };
}

ProductScreen.propTypes = {
  products: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectType: PropTypes.func,
  selectCategory: PropTypes.func,
  addToCard: PropTypes.func,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('translations')(ProductScreen)));


// WEBPACK FOOTER //
// ./src/containers/Product.js